module.exports = __webpack_public_path__ + "img/zhibo.09ede14f.png";